import React from "react";
import { Box, Heading, SimpleGrid, Text } from "@chakra-ui/react";
import Section from "./Section";
import { whyChooseUs } from "../data/content";

export default function WhyChooseUs() {
  return (
    <Section id="why-us" title="Why Choose Us">
      <SimpleGrid columns={{ base: 1, sm: 2, lg: 4 }} spacing={6}>
        {whyChooseUs.map((reason) => (
          <Box key={reason.title} textAlign="center" px={2}>
            <Box
              w="52px"
              h="52px"
              mx="auto"
              mb={5}
              borderRadius="lg"
              bg="brand.50"
              border="1px solid"
              borderColor="brand.200"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Box as="svg" viewBox="0 0 24 24" w="24px" h="24px" fill="none" stroke="currentColor" strokeWidth="2" color="brand.600">
                <path d="M20 6L9 17l-5-5" strokeLinecap="round" strokeLinejoin="round" />
              </Box>
            </Box>
            <Heading as="h3" fontSize="lg" mb={2}>
              {reason.title}
            </Heading>
            <Text color="ink.500" lineHeight="1.7">
              {reason.description}
            </Text>
          </Box>
        ))}
      </SimpleGrid>
    </Section>
  );
}
